// eslint-disable-next-line no-restricted-syntax
import * as Yup from 'yup'

export type FormValues = {
  purpose: string[]
  publish_content_to_other_tools_message?: string
  others_message?: string

  [key: string]: string | string[] | undefined
}

export type PurposeEnum =
  | 'store_offline'
  | 'share_docs_with_team'
  | 'publish_content_to_other_tools'
  | 'others'

export const purposeOptions = [
  {
    label: 'To store offline for future reference',
    value: 'store_offline',
  },
  {
    label: 'Sharing with other team members',
    value: 'share_docs_with_team',
  },
  {
    label: 'Upload the content to the required platform',
    value: 'publish_content_to_other_tools',
    otherField: {
      placeholder: 'Specify your CMS name',
    },
  },
  {
    label: 'Other reasons',
    value: 'others',
    otherField: {
      placeholder: 'Let us know what are other use cases for your download.',
    },
  },
]

export const validationSchema = Yup.object({
  purpose: Yup.array().min(1).required(),
  publish_content_to_other_tools_message: Yup.string()
    .trim()
    .when('purpose', {
      is: value => value.includes('publish_content_to_other_tools'),
      then: (schema: Yup.StringSchema) => schema.required(),
      otherwise: (schema: Yup.StringSchema) => schema,
    }),
})

export const bulkDownloadLS = {
  downloadModal: (companyId: string) => `bulk-download-modal-${companyId}`,
  downloadModalExpiryKey: (companyId: string) =>
    `bulk-download-modal-${companyId}-expires-in`,
  jobId: () => `bulk-download-job-id`,
}

export const showBulkDocsDownloadForm = (companyId: string) => {
  const downloadModalExpiry = localStorage.getItem(
    bulkDownloadLS.downloadModalExpiryKey(companyId)
  )
  if (!downloadModalExpiry) return true

  try {
    const expiryDate = new Date(Number.parseInt(downloadModalExpiry))
    if (new Date() > expiryDate) return true
    return false
  } catch (error) {
    return false
  }
}

export const setBulkDownloadFormLS = ({ companyId }: { companyId: string }) => {
  const DAYS_MONTH = 31
  const lsExpiry = new Date().setDate(new Date().getDate() + DAYS_MONTH)
  localStorage.setItem(bulkDownloadLS.downloadModal(companyId), 'true')
  localStorage.setItem(
    bulkDownloadLS.downloadModalExpiryKey(companyId),
    lsExpiry.toString()
  )
}
